import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';
import { Responsive } from 'semantic-ui-react';
import withSizes from 'react-sizes';
import OmkostningberegnerPresentation from './OmkostningsberegnerPresentation';
import { beregnOmkostninger } from '../../redux/actions/omkostninger.js';


const mapSizesToProps = ({ width }) => ({
  tablet: width < Responsive.onlyTablet.minWidth
});

let pendingCalculation = null;

const OmkostningberegnerContainer = props => {
  const { maxDepotVardi, tablet, udvidet } = props;
  const dispatch = useDispatch();
  const output = useSelector(state => state.omkostninger.output || {});

  const [params, setParams] = useState({
    pensionsopsparing: '',
    pensionindbetaling: '',
    forventetpensionsalder: 67,
    alder: 40,
    investeringsprofil: 'A',
    klimaAndel: '0',
    indeksAndel: '0',
    tegningsmaade: 'Arbejdsgiver',
    visberegningsdetaljer: false,
    kundekapital: true,
    kundekapitalBeregnesKunAfIndbetalingen: true,
    betalingomkostningrabat: '',
    saldoOmkostningRabat: false,
    visopsparingOvermaxModal: false,
    valgfriHoejAndel: '',
    valgfriLavAndel: ''
  });
  const [visOverMax, setVisOverMax] = useState(false);

  const addParams = useCallback((newParams) => {
    setParams({
      ...params,
      ...newParams
    });
  }, [params]);

  useEffect(() => {
    const opsparing = output.pensionsopsparingEfter1Aar;
    if (opsparing && maxDepotVardi && (opsparing >= maxDepotVardi))
      setVisOverMax(true);
  }, [maxDepotVardi, output.pensionsopsparingEfter1Aar]);

  useEffect(() => {
    if (pendingCalculation)
      clearTimeout(pendingCalculation);
    pendingCalculation = setTimeout(() => {
      if (udvidet)
        dispatch(beregnOmkostninger({
          ...params,
          betalingomkostningrabat: (params.betalingomkostningrabat || 0) / 100
        }));
      else
        dispatch(beregnOmkostninger({
          alder: params.alder,
          forventetpensionsalder: params.forventetpensionsalder,
          investeringsprofil: params.investeringsprofil,
          pensionindbetaling: params.pensionindbetaling,
          pensionsopsparing: params.pensionsopsparing,
          tegningsmaade: params.tegningsmaade,
          valgfriHoejAndel: params.valgfriHoejAndel,
          klimaAndel: params.klimaAndel,
          indeksAndel: params.indeksAndel,
        }));
      pendingCalculation = null;
    }, 500);

  }, [udvidet, params, dispatch]);

  const lukopsparingOvermaxModal = () => {
    setVisOverMax(false);
  };

  const genericFieldHandler = (event, data) => {
    let fieldValue = data.value;
    if (data.type === 'checkbox')
      fieldValue = data.checked;

    if (data['data-numeric'] === true) {
      const re = /^[0-9\b]+$/;
      if (fieldValue !== '' && !re.test(fieldValue))
        return;
    }

    let forventetpensionsalder = params.forventetpensionsalder;
    let alder = params.alder;

    if (data.name === 'forventetpensionsalder') {
      forventetpensionsalder = fieldValue;
    }
    if (data.name === 'alder') {
      alder = fieldValue;
    }

    if (alder > forventetpensionsalder) {
      alder = forventetpensionsalder;
    }


    let betalingomkostningrabat = params.betalingomkostningrabat;
    if (data.name === 'betalingomkostningrabat') {
      betalingomkostningrabat = fieldValue;
      if (betalingomkostningrabat > 100)
        betalingomkostningrabat = '100';
      if (betalingomkostningrabat < 0)
        betalingomkostningrabat = '0';
    }

    let klimaAndel = params.klimaAndel;
    if (data.name === 'klimaAndel') {
      const samletAndel = parseInt(fieldValue || 0, 10) + parseInt(params.indeksAndel || 0, 10);
      klimaAndel = fieldValue;
      if (samletAndel > 100)
        klimaAndel = (100 - parseInt(params.indeksAndel || 0, 10)).toString();
      if (klimaAndel > 100)
        klimaAndel = '100';
      if (klimaAndel < 0)
        klimaAndel = '0';
    }

    let indeksAndel = params.indeksAndel;
    if (data.name === 'indeksAndel') {
      const samletAndel = parseInt(fieldValue || 0, 10) + parseInt(params.klimaAndel || 0, 10);
      indeksAndel = fieldValue;
      if (samletAndel > 100)
        indeksAndel = (100 - parseInt(params.klimaAndel || 0, 10)).toString();
      if (indeksAndel > 100)
        indeksAndel = '100';
      if (indeksAndel < 0)
        indeksAndel = '0';
    }

    let valgfriHoejAndel = params.valgfriHoejAndel;
      if (data.name === 'valgfriHoejAndel') {
          valgfriHoejAndel = fieldValue;
          if (valgfriHoejAndel > 100)
              valgfriHoejAndel = '100';
          if (valgfriHoejAndel < 0)
              valgfriHoejAndel = '0';
    }

    addParams({
      [data.name]: fieldValue,
      forventetpensionsalder,
      alder,
      betalingomkostningrabat,
      klimaAndel,
      indeksAndel,
      valgfriHoejAndel
    });

  };

  const toggleDetaljer = () => {
    addParams({
      visberegningsdetaljer: !params.visberegningsdetaljer
    });
  };

  return <OmkostningberegnerPresentation
    tablet={tablet}
    udvidet={udvidet}
    visberegningsdetaljer={params.visberegningsdetaljer}
    visopsparingOvermaxModal={visOverMax}
    genericFieldHandler={genericFieldHandler}
    lukopsparingOvermaxModal={lukopsparingOvermaxModal}
    input={params}
    toggleDetaljer={toggleDetaljer}
    output={visOverMax ? {} : {
      omkostningerAfDinBetalingTilPFA: output.omkostningerAfDinBetalingTilPFA,
      omkostningerAfDinBetalingTilDitPengeinstitut: output.omkostningerAfDinBetalingTilPengeinstituttet,
      omkostningerAfDinSaldoTilPfaOgDitPengeinstitut: output.omkostningerAfSaldoPFAOgPengeinstitut,
      investeringsOmkostninger: output.investeringsomkostninger,
      standardAaok: output.standardAAOK,
      standardAaop: output.standardAAOP,
      nuvaerendePensionsopsparing: parseFloat(params.pensionsopsparing || 0),
      aarligIndbetalingEfterAmb: output.aarligIndbetalingEfterAmb,
      investeringsAfkast: output.investeringsAfkast,
      administrationOgInvesteringsomkostninger: output.standardAAOK,
      pensionsafkastskat: output.pensionsafkastskat,
      pensionsopsparingEfter1Aar: output.pensionsopsparingEfter1Aar
    }}
  />;
};

OmkostningberegnerContainer.propTypes = {
  maxDepotVardi: PropTypes.number.isRequired,
  udvidet: PropTypes.bool.isRequired,
  omkostninger: PropTypes.shape({
    output: PropTypes.object.isRequired
  }).isRequired
};

OmkostningberegnerContainer.defaultProps = {
  maxDepotVardi: null,
  udvidet: false,
  omkostninger: {
    output: {}
  }
};

export default withSizes(mapSizesToProps)(OmkostningberegnerContainer);
